import React from 'react'
import PropTypes from 'prop-types';
import { CoachTile } from "@myplay/ui";

import { NewCoachTile } from '..';
import './TeamCoaches.scss';

const TeamCoaches = ({ coaches, onAssignCoach, onCoachClick })=> {

  return (
    <div className="team-coachs" data-testid="team-coaches">
      {coaches.map(coach =>
        <button type="button" onClick={()=> onCoachClick(coach)} data-testid="coach-button">
          <CoachTile coach={coach}/>
        </button>
      )}
      <NewCoachTile onClick={onAssignCoach}/>
    </div>
  );
};

TeamCoaches.propTypes = {
  coaches: PropTypes.array,
  onAssignCoach: PropTypes.func, 
  onCoachClick: PropTypes.func
};

TeamCoaches.defaultProps = {
  coaches: [],
  onAssignCoach: ()=> {},
  onCoachClick: ()=> {}
};

export default TeamCoaches;